// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"74ed399d","443":"1394c663","740":"cca58702"}[chunkId] + ".chunk.css";
};